import axios from 'axios';

import { LogService } from '../../../../services/log-service';

export const getSellerLabelProviderBalances = async () => {
  try {
    const response = await axios.get('seller/labelproviders/balances');
    return response?.data ?? [];
  } catch (error) {
    LogService.logError(new Error('Error fetching Provider Balances', { cause: error }));
    throw error;
  }
};

export const changeNickname = async (walletId, nickname) => {
  try {
    const response = await axios.put(`/wallet/${walletId}/nickname`, {
      nickname,
    });
    const result = response?.data ?? [];
    return result;
  } catch (error) {
    LogService.logError(new Error('Error changing nickname', { cause: error }));
    throw error;
  }
};

export const manageAutoFunding = async (sellerLabelProviderId, config) => {
  const response = await axios.put(`/sellerProvider/${sellerLabelProviderId}/autoFunding`, config);
  return response?.data ?? {};
};

export const fundAccount = async (sellerLabelProviderId, amount, userId) => {
  const addFundData = {
    amount: amount?.value,
    code: amount?.code,
    userId,
    sellerLabelProviderId,
  };
  const response = await axios.post('/postage/purchase', addFundData);
  return response?.data ?? {};
};

export const saveDefaultPurchase = async (sellerLabelProviderId, amount) => {
  const response = await axios.put(`/sellerProvider/${sellerLabelProviderId}/defaultPurchase`, { amount });
  return response?.data ?? {};
};
